<template>
  <div class="wrapper">
    <div class="loginContainer">
      <v-col>
        <v-row>
          <h1>Привіт!</h1>
        </v-row>
        <v-row>
          <p class="text">Введіть Ваш логін та пароль від системи.</p>
        </v-row>
        <v-row>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            >
              <v-col
                cols="12"
                sm="12"
              >
                <v-row>
                  <h2 class="initials"> Логін</h2>
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      outlined
                    ></v-text-field>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <v-row>
                    <h2 class="initials">Пароль</h2>
                    <v-text-field
                      type="password"
                      v-model="password"
                      outlined
                      :rules="passwordRules"
                    ></v-text-field>
                </v-row>
              </v-col>
             <v-btn
              class="mr-4"
              block
              color="#549EC7"
              @click="submitData"
            >
            <b class="submitBtn"> Увійти</b>
          </v-btn>
          </v-form>
          <p class="errorMessage" v-if="show" >Не вірний логін або пароль </p>
        </v-row>
      </v-col>
    </div>
  </div>
</template>
<script>

import JwtDecode from 'jwt-decode'
import WelcomebookManager from '../../managers/welcomeBookManager'

export default {
  name: 'authPage',
  data: () => ({
    email: '',
    password: '',
    valid: true,
    show: false,
    emailRules: [
      v => !!v || 'E-mail обов\'язковий',
      v => /.+@.+\..+/.test(v) || 'E-mail має невірний формат'
    ],
    passwordRules: [
      v => !!v || 'Пароль обов\'язковий'
    ],
    linkWelcomebook: String
  }),
  methods: {
    async submitData() {
    // singIn user
      if (this.$refs.form.validate()) {
        const manager = new WelcomebookManager()
        this.loading = true
        try {
          const token = await manager.getToken(this.email, this.password)
          if (JwtDecode(token.access_token)) {
            await this.$store
              .dispatch('singIn', token)
            this.$router.push({ name: 'welcomebook' })
          } else {
            this.show = true
          }
        } catch (e) {
          this.show = true
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  display: flex;
}
.loginContainer {
    max-width: 400px;
    padding: 24px;
    margin: auto;
    background: #FCFCFC;
}
.text {
    left: 0%;
    right: 0%;
    top: 47.83%;
    bottom: 0%;
    font-size: 16px;
    color: #3A3A3A;
    b {
        color: #549EC7;
    }
    margin: 12px 0px;
}
.initials {
    position: static;
    width: 360px;
    left: calc(50% - 360px/2);
    top: 0%;
    bottom: 70.73%;
    color: #3A3A3A;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    margin: 8px 0px;
}
.submitBtn {
    color: #FCFCFC;
    font-size: 13px;
}
.errorMessage {
  font-size: 15px;
  color: red;
  font-weight: 600;
  margin: auto;
}
</style>
